import { USER_FLOW_BASE } from '../type_name'
import { VSpacer } from 'vuetify/lib'
import { UserFlowBase } from '../components_from_custumer'

export default {
    name: USER_FLOW_BASE,
    props: {
        field: {
            type: Object,
        },
        value: {
            type: Object
        }
    },
    methods: {
        // 生成 VSpacer
        setVSpacer(h) {
            if (this.vSpacer) {
                return this.vSpacer
            }
            return this.vSpacer = h(VSpacer)
        }
    },
    computed: {
        title() {
            const { flow_title } = this.field
            const title_type = Object.prototype.toString.call(flow_title)
            let title = ''
            switch (title_type) {
                case '[object String]':
                    title = this.value[flow_title]
                    break;
                case '[object Function]':
                    title = flow_title(this.field, this.value)
                    break;
                default:
                    break;
            }
            return title
        }
    },
    render(h) {
        const { label, key } = this.field
        let user_flow_base = h('span', {}, '-')
        if (this.value[key]) {
            user_flow_base = h(UserFlowBase, {
                style: {
                    border: 'thin solid rgba(0, 0, 0, 0.12)',
                    'border-radius': '5px',
                    padding: '0px 15px',
                },
                props: {
                    user_flow: this.value[key],
                    model: this.value,
                    title: this.title
                }
            }) 
        }
        return h('div', {
            style: {
                display: 'flex',
                width: '100%'
            }
        }, [
            h('span', {
                style:{
                    'white-space':'nowrap',
                    'margin-right': '10px'
                }
            }, label),
            this.setVSpacer(h),
            user_flow_base
        ])
    }
}